import { render, staticRenderFns } from "./EditEventModal.vue?vue&type=template&id=67a974dd"
import script from "./EditEventModal.vue?vue&type=script&lang=js"
export * from "./EditEventModal.vue?vue&type=script&lang=js"
import style0 from "./EditEventModal.vue?vue&type=style&index=0&id=67a974dd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports